import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './initialState'
import { MonthlyCut } from '@/modules/allies/monthlyCut/types/MonthlyCut.ts'

const monthlyCutSlice = createSlice({
  name: 'monthlyCut',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setSelectedAllyId: (state, action: PayloadAction<string>) => {
      state.selectedAllyId = action.payload
    },
    setSelectedRows: (state, action: PayloadAction<MonthlyCut[]>) => {
      state.selectedRows = action.payload
    },
    reset: () => initialState
  }
})

export const monthlyCutActions = monthlyCutSlice.actions
export const { reducer: monthlyCutReducer } = monthlyCutSlice
